import { Component, Input } from '@angular/core';

// comment.model.ts (create this file or place it in the same file as the component)
export interface MetaInfo {
    createdByName: string;
    createdAt: Date;
}

@Component({
    selector: 'app-editor-meta-info',
    template: `
        <div class="meta-user">
            <ham-avatar type="circle" size="regular" [fullName]="meta.createdByName"></ham-avatar>
        </div>
        <div class="meta-created">
            <div class="created-by">{{ meta.createdByName }}</div>
            <div class="created-at">{{ meta.createdAt | date : 'short' }}</div>
        </div>
    `,
    styleUrls: ['./metaInfo.component.scss'],
})
export class MetaInfoComponent {
    @Input() meta!: MetaInfo; // Use the interface for the input property
}
